import React from "react";
import PropTypes from "prop-types";
import "./timeline-simple.scss";

function TimelineSimple({ items }) {
  return (
    <div className="timeline-simple">
      {items?.map((item, index) => {
        const isLast = index === items.length - 1;
        return (
          <div key={item.id} className="timeline-simple-item">
            <div className="timeline-simple-dot" />
            {!isLast && <div className="timeline-simple-line" />}
            <div className="timeline-simple-content">
              <p className="timeline-simple-title para-body-m-regular">{item.title}</p>
              <p className="timeline-simple-subtitle para-body-s-regular">{item.subtitle}</p>
            </div>
          </div>
        );
      })}
    </div>
  );
}

TimelineSimple.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
      title: PropTypes.string.isRequired,
      subtitle: PropTypes.string,
    })
  ).isRequired,
};

export default TimelineSimple;
